import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import {
  IoCloseSharp,
  IoIosArrowDown,
  IoIosArrowUp,
  TfiFiles,
} from "../../components/utils/icons";
import { useStateContext } from "../../context/ContextProvider";
import { CaseFilter, TextQill, UsersFilter } from "./utils";
import { DLabel, DSpinButton } from "../utils/Form";

import { toast } from "react-toastify";
import { Loader, PDFViewer, Pagination } from "../utils";

import { BaseUrl } from "../../server";
import { getFillterUsers } from "../../redux/actions/user";
import { getFilltercases, getcase } from "../../redux/actions/cases";
function CreatePleading() {
  const { t } = useTranslation();
  const { currentColor } = useStateContext();

  const [errorMessage, setErrorMessage] = useState("");
  const [isSpinner, setIsSpinner] = useState(false);
  const [caseId, setCaseId] = useState();
  const [clientId, setClientId] = useState();
  const [pleadingNumber, setPleadingNumber] = useState("");
  const [pleadingName, setPleadingName] = useState("");
  const [clientName, setClientName] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [caseNumber, setCaseNumber] = useState("");
  const [opponentName, setOpponentName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [date, setDate] = useState();
  const [notes, setNotes] = useState();
  const [openMenu, setOpenMenu] = useState(false);

  const [file, setFile] = useState(null);
  const [fileShow, setFileShow] = useState();
  const [hasAccount, setHasAccount] = useState(false);

  const dispatch = useDispatch();

  const { caseData, isLoadingCase } = useSelector((state) => state.Cases);
  const { isLoading, FillterUsers, pagination, errfiter } = useSelector(
    (state) => state.Users
  );
  const casechangeHandel= (casee) => {
    setCaseId(casee._id);
    
      if (casee.clientId?._id){
        setClientId(casee.clientId?._id);
     
      }
      setClientName(casee.clientName );
      setOpponentName(casee.opponentName );   
  }
  const {  FillterCases, paginationCase } = useSelector((state) => state.Cases);
  const totalPages = pagination?.totalPages;
  const totalPagesCase = paginationCase?.totalPages;
  useEffect(() => {
   
    dispatch(getFilltercases(page, limit,
      caseNumber,
    
    ));
  }, [page, limit,
    caseNumber,
 ,dispatch]);
  useEffect(() => {
    
    dispatch(getFillterUsers(page, limit, phoneNumber, email, name));
  }, [page, limit, phoneNumber, email, name, dispatch]);
  const fileHandle = (e) => {
    const selectedFile = e.target.files[0];
    // تحقق مما إذا تم اختيار ملف
    if (!selectedFile) {
      toast.warning(
        <span className="text-tcolor-4 font-kufi dark:text-tcolor-1 text-sm">
          الرجاء اختيار ملف
        </span>
      );
      setErrorMessage(
        <span className=" font-kufi text-red-500 text-lg">
          الرجاء اختيار ملف
        </span>
      );
      return;
    }

    if (selectedFile.type !== "application/pdf") {
      toast.warning(
        <span className="text-tcolor-4 font-kufi dark:text-tcolor-1 text-sm">
          الرجاء اختيار ملف PDF فقط
        </span>
      );
      setErrorMessage(
        <span className="font-kufi text-red-500 text-sm">
          الرجاء اختيار ملف PDF فقط
        </span>
      );
      setFile(null);
      return;
    }

    // إذا كان الملف صالحًا
    setErrorMessage("");
    setFile(selectedFile);
  };


  const changefile = (file) => {
    if (file) {
      const tempUrl = { url: URL.createObjectURL(file) }; // كائن مباشر
      setFileShow(tempUrl);
      setFile(file);
    }
  };
  const removefile = () => {
    setFile();
    setFileShow();
  };

 
  const CreatePleading = async (newForm) => {
    try {
      const config = {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
      };
      const { data } = await axios.post(
        `${BaseUrl}/pleading/create`,
        newForm,
        config
      );
      if (data.success) {
        // عرض رسالة نجاح
        toast.success(
          <span className="font-kufi text-tcolor-4 dark:text-tcolor-1 text-sm">
            {t("pleading created successfully!")}
          </span>
        );
        setIsSpinner(false);
        setPleadingNumber("");
        setPleadingName("");
        setClientId("");
        setName("");
        setEmail("");
        setPhoneNumber("");
        setCaseId("");
        setCaseNumber("");
        setOpponentName("");
        setNotes("");
        setDate("");
        setClientName("");
        setFile();
        setFileShow();
      }
    } catch (error) {
      // عرض رسالة خطأ
      toast.error(error.response?.data?.message);
      setIsSpinner(false);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSpinner(true);
   
    if (file instanceof File === false) {
      toast.warning(
        <span className="font-kufi text-tcolor-4 dark:text-tcolor-1 text-sm">
          {t("Please Add file")}
        </span>
      );
      setIsSpinner(false);
    } else {
      const newForm = new FormData();

      newForm.append("file", file);
      newForm.append("date", date);
      newForm.append("caseId", caseId);
      if (clientId) {
        newForm.append("clientId", clientId);
      }
    
      newForm.append("notes", notes);
      newForm.append("pleadingNumber", pleadingNumber);
    
      newForm.append("opponentName", opponentName);
      newForm.append("pleadingName", pleadingName);
      newForm.append("clientName", clientName);

      CreatePleading(newForm);
    }
  };

  return (
    <>
      {isLoading  ? (
        <Loader />
      ) : (
        <div className="w-[90%] bg-back-primery lg:w-[50%] m-2 md:m-10 mt-24 p-2 md:p-10  rounded-3xl">
          <h3 className="text-xl font-semibold text-color-1 font-kufi color text-center">
            {t("Create Pleading")}
          </h3>
          <form onSubmit={handleSubmit}>
            <br />
            <div>
            <div className="flex flex-col">
<div onClick={()=>setOpenMenu(!openMenu)} className=" px-2.5 pb-2.5 flex flex-row pt-4 w-full body-1 text-tcolor-5  bg-n-1  justify-between  rounded-lg border border-back-darktertiary/50  appearance-none  focus:outline-none focus:ring-0 focus:border-color-1 peer">
{t("Select Case")} {openMenu ? (<IoIosArrowUp />):(<IoIosArrowDown />)}
</div>
              { openMenu &&  <div className="w-full bg-back-secondary flex flex-col items-center justify-center rounded-md p-2">
                  <CaseFilter
               caseNumber={caseNumber}
               setCaseNumber={setCaseNumber}
                  />
                  <div className="py-3">
                    {FillterCases &&
                      FillterCases.map((casee) => (
                        <div
                          key={casee._id}
                          className="flex items-center  justify-between mb-2"
                        >
                          <span className="text-tcolor-5 font-kufi text-sm mx-4 ">
                          {t("the Case Number")}  {casee.caseNumber}
                          </span>
                          <input
                            type="checkbox"
                            checked={caseId === casee._id}
                            onChange={() => casechangeHandel(casee)}
                            className="form-checkbox h-5 w-5 text-color-1"
                          />
                        </div>
                      ))}
                    <Pagination
                      currentPage={page}
                      totalPages={totalPagesCase}
                      setPage={setPage}
                    />
                  </div>
                </div>
}
              </div>
    
              <DLabel
                labelText="Pleading Number"
                value={pleadingNumber}
                onChange={(e) => {
                  setPleadingNumber(e.target.value);
                }}
                required={true}
                type="text"
                name="pleadingNumber"
              />
              <DLabel
                labelText="Pleading Name"
                value={pleadingName}
                onChange={(e) => {
                  setPleadingName(e.target.value);
                }}
                required={true}
                type="text"
                name="pleadingNumber"
              />
         
              <DLabel
                labelText="client Name"
                value={clientName}
                onChange={(e) => {
                  setClientName(e.target.value);
                }}
                required={true}
                type="text"
                name="caseNumber"
              />
              <DLabel
                labelText="opponant Name"
                value={opponentName}
                onChange={(e) => {
                  setOpponentName(e.target.value);
                }}
                required={true}
                type="text"
                name="caseNumber"
              />
              <DLabel
                labelText="Date"
                value={date}
                onChange={(e) => {
                  setDate(e.target.value);
                }}
                required={true}
                type="date"
                name="date"
              />

              <br />
              <div className="relative flex-col items-center  mb-4 h-auto pb-5">
                <label className="pb-2 text-tcolor-5 text-md font-kufi">
                  {" "}
                  {t("Write the Notes")}
                </label>{" "}
                <TextQill text={notes} setText={setNotes} />
              </div>
              <label className="pb-2 text-tcolor-5  text-md font-kufi">
                {t("Upload file")}
                <span className="text-red-500">*</span>
              </label>
              <input
                type="file"
                name=""
                id="file-upload"
                className="hidden"
                onChange={fileHandle}
              />
              {errorMessage && <p className="text-red-500">{errorMessage}</p>}
              {file ? (
                <div className="h-[180px] relative">
             

                  <label htmlFor="file-upload">
                  <PDFViewer
     
        fileName={file.name}
        fileUrl={file instanceof File && URL.createObjectURL(file) }
      
      />
                
                  </label>
                  <input
                    onChange={(e) => changefile(e.target.files[0])} // تصحيح إلى files[0]
                    type="file"
                    id="file-upload" // معرف فريد
                    className="hidden"
                  />
                  <span
                    onClick={removefile}
                    className="p-2 z-10 cursor-pointer hover:shadow-lg hover text-white absolute top-1 right-1 rounded-full"
                    style={{ backgroundColor: currentColor }}
                  >
                    <IoCloseSharp />
                  </span>
                </div>
              ) : (
                <label
                  className="flex mt-2 justify-center items-center flex-col max h-[180px] cursor-pointer border rounded-lg border-dashed hover:border-indigo-500  text-[#d0d2d6]"
                  htmlFor="file-upload" // مطابقة مع المعرف الجديد
                  style={{ borderColor: currentColor }}
                >
                  <span>
                    <TfiFiles size={40} color={currentColor} />
                  </span>
                  <span
                    className="text font-kufi text-md"
                    style={{ color: currentColor }}
                  >
                    {t("Select file")}
                  </span>
                </label>
              )}

              <input
                onChange={fileHandle}
                className="hidden"
                type="file"
                id="file-upload"
              />
              <br />
            </div>
            <DSpinButton isLoading={isSpinner}>{t("Create")}</DSpinButton>
          </form>
        </div>
      )}
    </>
  );
}

export default CreatePleading;
